var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"180px"}},[_c('div',{staticStyle:{"height":"50px"}}),_c('div',{staticClass:"arrow_box",staticStyle:{"background-color":"rgb(183, 222, 242)"}},[_c('span',{staticStyle:{"padding":"10px"}},[_vm._v(" "+_vm._s(_vm.tooltip && _vm.tooltip.currentDate && new Date(_vm.tooltip.currentDate).toLocaleString())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }